import { IExportSasStatusResult } from "src/app/ui/repositories/file-export.repository";
import { ExportOrderKey } from "./export-order-key";
import { IFileFileExportResult } from "./file-export-result";
import { FileExportService } from "src/app/ui/services/file-export.service";
import { Toast } from "src/app/ui/components/toast/toast";

export interface IFileExportOrderRequestBase {
  orderExport(): Promise<ExportOrderKey>;
  getFileExportName(): string;
  showError(error: any): void;
}
export interface IFileExportOrderRequest extends IFileExportOrderRequestBase {
  downloadFile(orderKey: ExportOrderKey): Promise<IFileFileExportResult>;
  isFileExportReady(orderKey: ExportOrderKey): Promise<boolean>;

}
export interface ISasFileExportRequest extends IFileExportOrderRequestBase {
  getExportSasStatus(orderKey: ExportOrderKey): Promise<IExportSasStatusResult>;
  downloadViaSasLink(fileName: string, downloadUri: string): Promise<void>;
}

export abstract class BaseSasFileExportRequest implements ISasFileExportRequest {
  constructor(
    protected fileExportService: FileExportService,
    protected toast: Toast
  ) { }

  abstract getFileExportName(): string;
  abstract orderExport(): Promise<ExportOrderKey>;

  public async getExportSasStatus(orderKey: ExportOrderKey): Promise<IExportSasStatusResult> {
    return this.fileExportService.getExportSasStatus(orderKey);
  }

  public async downloadViaSasLink(fileName: string, downloadUri: string): Promise<void> {
    const a = document.createElement("a");
    a.href = downloadUri;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public showError(error: any): void {
    this.toast.showWarningToast(error);
  }
}